import { render, staticRenderFns } from "./add-album.component.vue?vue&type=template&id=54aa8d8e"
import script from "./add-album.component.vue?vue&type=script&lang=js"
export * from "./add-album.component.vue?vue&type=script&lang=js"
import style0 from "./add-album.component.vue?vue&type=style&index=0&id=54aa8d8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports